import React, { useRef, useState, useEffect } from 'react';
import { Box } from 'components/Wrapped';
import styles from './Form.module.scss';

const TwoFactorInput = ({ onChange, name, value = '', reset, isLoading }) => {
  const [code, setCode] = useState('');
  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];

  const resetCode = () => {
    inputRefs.forEach((ref) => {
      ref.current.value = '';
    });
    inputRefs[0].current.focus();
    setCode('');
  };

  useEffect(() => {
    if (code.length === 6) {
      onChange(code);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  useEffect(() => {
    resetCode();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset]);

  function onInput(e, index) {
    const input = e.target;
    const previousInput = inputRefs[index - 1];
    const nextInput = inputRefs[index + 1];
    const newCode = [...code];

    if (/^[a-z]+$/.test(input.value)) {
      const uc = input.value.toUpperCase();
      newCode[index] = uc;
      inputRefs[index].current.value = uc;
    } else {
      newCode[index] = input.value;
    }
    setCode(newCode.join(''));

    input.select();

    if (input.value === '') {
      if (previousInput) {
        previousInput.current.focus();
      }
    } else if (nextInput) {
      nextInput.current.select();
    }
  }

  function onFocus(e) {
    e.target.select();
  }

  function onKeyDown(e, index) {
    const input = e.target;
    const previousInput = inputRefs[index - 1];
    // const nextInput = inputRefs[index + 1];

    if ((e.keyCode === 8 || e.keyCode === 46) && input.value === '') {
      e.preventDefault();
      setCode((prevCode) => prevCode.slice(0, index) + prevCode.slice(index + 1));
      if (previousInput) {
        previousInput.current.focus();
      }
    }
  }

  const onPaste = (e) => {
    const pastedCode = e.clipboardData.getData('text');

    if (pastedCode.length === 6) {
      setCode(pastedCode);
      inputRefs.forEach((inputRef, index) => {
        inputRef.current.value = pastedCode.charAt(index);
      });
    }
  };

  return (
    <Box pad="none" direction="row" gap="16px">
      {[
        [0, 1, 2],
        [3, 4, 5],
      ].map((part, partIndex) => (
        <Box key={'part' + partIndex} direction="row" pad="none" gap="4px">
          {part.map((index) => (
            <input
              key={'input' + index}
              type="text"
              maxLength={1}
              onChange={(e) => onInput(e, index)}
              ref={inputRefs[index]}
              autoFocus={index === 0}
              onFocus={onFocus}
              onKeyDown={(e) => onKeyDown(e, index)}
              onPaste={onPaste}
              disabled={isLoading}
              className={styles.twoFactorInput}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default TwoFactorInput;
